import { render, staticRenderFns } from "./SubDriverAccountsDetail.vue?vue&type=template&id=0198ca63&scoped=true&"
import script from "./SubDriverAccountsDetail.vue?vue&type=script&lang=js&"
export * from "./SubDriverAccountsDetail.vue?vue&type=script&lang=js&"
import style0 from "./SubDriverAccountsDetail.vue?vue&type=style&index=0&id=0198ca63&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0198ca63",
  null
  
)

export default component.exports